// extracted by mini-css-extract-plugin
export const root = "next-page-module--root--2PTJc";
export const image = "next-page-module--image--3VfXC";
export const text = "next-page-module--text--1HoYQ";
export const link = "next-page-module--link--3cdyE";